import {
  clearFSMBusinessListDetails,
  fetchFSMBusinessListFail,
  fetchFSMBusinessListStarted,
  fetchFSMBusinessListSuccess
} from '../../../reducer/sources/FSMListReducer';
import { ClearAllFSMList, FetchAllFSMListFailure, FetchAllFSMListFailurePayload, FetchAllFSMListStarted, FetchAllFSMListSuccess, FetchAllFSMListSuccessPayload } from '../../types/sources/GetFSMListTypes';

/**
 * Fetch All FSMList  started saga action
 * @returns service FSMList started action
 */
export const getAllFSMListStarted = (): FetchAllFSMListStarted => ({
  type: fetchFSMBusinessListStarted.type
});

/**
 * Fetch all FSMList success saga action
 * @param payload : all FSMList data
 * @returns success action
 */
export const getAllFSMListSuccess = (
  payload: FetchAllFSMListSuccessPayload
): FetchAllFSMListSuccess => ({
  type: fetchFSMBusinessListSuccess.type,
  payload
});

/**
 * Fetch All FSMList Faild saga action
 * @param payload : error message
 * @returns Failure saga action
 */
export const fetchAllFSMListFailure = (
  payload: FetchAllFSMListFailurePayload
): FetchAllFSMListFailure => ({
  type: fetchFSMBusinessListFail.type,
  payload
});

/**
 * Clear All FSMLists saga action
 * @param payload : error message
 * @returns Failure saga action
 */
export const clearAllFSMList = (): ClearAllFSMList => ({
  type: clearFSMBusinessListDetails.type
});
